export const ONE_HOUR_MILLISECONDS = 60 * 60 * 1000;
